// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__a24K-","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2m1tx"};